// extracted by mini-css-extract-plugin
export default {"icon":"u0f26","menu":"iVRaj"};